import { render, staticRenderFns } from "./adminCounts.vue?vue&type=template&id=2950a040&scoped=true&"
import script from "./adminCounts.vue?vue&type=script&lang=js&"
export * from "./adminCounts.vue?vue&type=script&lang=js&"
import style0 from "./adminCounts.vue?vue&type=style&index=0&id=2950a040&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950a040",
  null
  
)

export default component.exports